const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("GA realtime", "uipress-pro"),
  moduleName: "uip-google-realtime",
  description: __("Displays live visitor data about your site", "uipress-pro"),
  category: __("Analytics", "uipress-pro"),
  group: "analytics",
  icon: "schedule",
};
